import { RootState } from "~/store/rootReducer"

export const isLoadingSelector = (state: RootState) => state.loading.isLoading
export const loadingTitleSelector = (state: RootState) => state.loading.title
